import { useLanguage } from '../../context/LanguageContext.js';
import { usei18n } from '../../i18n/i18n.js';
import { extractDateAndTimeFromTimestamp } from '../../shared/utilities.js';
import AddDoseFab from '../AddDoseFab.js';
import './EmptyState.css';

const EmptyState = ({ onAdd, onAddLetter }) => {
  const { language } = useLanguage();
  const [date,] = extractDateAndTimeFromTimestamp(Date.now(), language);
  const i18n = usei18n(language);
  return (
    <div className="entries-empty-wrapper">
      <div className="entries-empty">
        <div className="dose-entry" onClick={onAdd}>
          <div className="datetime">
            <p className="date">{date}</p>
            <p className="time">00:00</p>
          </div>
          <div className="dose-size">
            <span className="size">0.0</span>
            <span className="ml">{i18n('doseUnit')}</span>
          </div>
        </div>
      </div>
      <AddDoseFab className="empty" onAddDose={onAdd} onAddLetter={onAddLetter} />
    </div>
  );
};

export default EmptyState;
